import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import type { IEventType } from '../../../stores/model/metamodel/event_type';

/**
 * Check if an event type is consistend.
 *
 * Checks if:
 * - ownerEventType and inheritance are either both set or both empty
 */

class EventConsistencyCheck extends Check<IEventType> {
  static description = 'Check for event consistency';

  check(): Report {
    this.report = new Report();

    // Old check checked if all methods in the events method list had their
    // event set to the event.  The internal model state is now setup in a way
    // that such inconsistencies cannot exist.

    // The owner event and inheritance should either be both set (for a
    // specialised event) or both unset (for a normal event)
    if (
      (this.element.ownerEventType != null && this.element.inheritance == null) ||
      (this.element.ownerEventType == null && this.element.inheritance != null)
    ) {
      this.report.addMessage(
        MessageType.ERROR,
        'A specialised event must have both owner event type and inheritance set.',
        this,
        this.element
      );
    } else {
      this.report.addMessage(
        MessageType.INFORMATION,
        'Event variables are set correctly',
        this,
        this.element
      );
    }

    return this.report;
  }
}

export default EventConsistencyCheck;
